// VipBadge.js
import React from "react";
import "./VipBadge.css";

import vip1 from "assets/images/info/vip/VIP1.png";
import vip2 from "assets/images/info/vip/VIP2.png";

const vipAssets = {
  VIP1: { image: vip1, color: "#da7e19" },
  VIP2: { image: vip2, color: "grey" },
};

const VipBadge = ({ vipLevel, color, imageSize=60, textSize=60 }) => {
  const { image: vipImage, color: defaultColor } = vipAssets[vipLevel] || {};

  const finalColor = color || defaultColor || "#da7e19";

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ marginRight: "5%" }}
    >
      <div className="d-flex justify-content-center align-items-center">
        <img
          src={vipImage}
          alt={vipLevel}
          style={{ maxHeight: `${imageSize}px`, maxWidth: `${imageSize}px` }}
        />
      </div>
      <div
        className="vip-text-div d-flex justify-content-center align-items-center"
        style={{ margin: "0px 5px 0px -1px", "--vip-color": finalColor, "--vip-textsize": `${textSize}px` }}
      >
        <p className="mb-0" style={{ fontSize: `${textSize*(16/60)}px` }}>
          {vipLevel}
        </p>
      </div>
    </div>
  );
};

export default VipBadge;
